import { useState } from "react";
import { Spacer } from "../../components/Layout/Layout";
import useTranslations from "../../core/i18n/useTranslations";
import { useSaveObject } from "../../core/SaveObjectContext/hooks";
import useUser from "../../core/user/useUser";
import Button from "../../ui-lib/components/Button/Button";
import { PopupMenu } from "../../ui-lib/components/Menus/PopupMenu";
import { PopupContextMenuLinkButton } from "../../ui-lib/components/Menus/PopupContextMenu/PopupContextMenuLinkButton";
import useSharedLocation from "./SharedLocationContext/useSharedLocationContext";
import { notify } from "../../ui-lib/components/Alerts/Toast";
import LocationDeleteModal from "./LocationDeleteModal";
import { useHistory } from "react-router-dom";

const parentPath = "/adminportal/locations";

const LocationActions = () => {
  const user = useUser();
  const history = useHistory();
  const t = useTranslations();
  const { isDirty } = useSaveObject();
  const { setIsLoading, fetchLocation, formRef, location } =
    useSharedLocation();
  const [deletionModalOpen, setDeletionModalOpen] = useState<boolean>(false);
  const canDelete = user.config?.show.includes("DeleteKnownLocations");
  const additionalFieldsEnabled = user.config?.show.includes(
    "EnableAdditionalLocationFields",
  );

  return (
    <>
      {formRef && (
        <Button
          text={t("Common:save")}
          onClick={async () => {
            setIsLoading(true);
            const result = await formRef?.submitForm?.();
            if (result?.status) {
              await fetchLocation();
            }
            notify({
              message: t("Locations:edited_success"),
            });
            setIsLoading(false);
          }}
          disabled={!isDirty}
        />
      )}
      {canDelete &&
        ((additionalFieldsEnabled && location?.klType === "ROOM") ||
          location?.klType !== "ROOM") && (
          <>
            <Spacer size={8} />
            <PopupMenu variant="secondary" buttonText={t("Common:other")}>
              <PopupContextMenuLinkButton
                icon="trash"
                text={t("Common:delete")}
                onClick={() => setDeletionModalOpen(true)}
              />

              <LocationDeleteModal
                isOpen={deletionModalOpen}
                onClose={() => setDeletionModalOpen(false)}
                onDelete={(success) => {
                  if (success) {
                    history.replace(parentPath);
                  }
                }}
                locations={location ? [location] : []}
                identifiersPresent={location?.hasDataDefinitions}
              />
            </PopupMenu>
          </>
        )}
    </>
  );
};

export default LocationActions;
